var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"oabat-icon"},[_c('svg',{staticClass:"oabat-icon__svg",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","role":"img","aria-hidden":"true"}},[_c('path',{attrs:{"d":_vm.path}})])])}
var staticRenderFns = []

export { render, staticRenderFns }